import React, { useState } from 'react';
import SectionHeader from 'partial/components/SectionHeader';
import { HiDocumentAdd } from 'react-icons/hi';
import Table, { tableEditDelete } from 'partial/components/Table';
import Button from 'partial/components/Button';
import Pagination from 'partial/components/Pagination';
import { showAlert, showDrawer } from 'partial/components/Modal';
import ChannelBranchModal from '../modals/ChannelBranchModal';
import { useChannelBranchList, useDeleteChannelBranch } from '../hooks';
import { CHANNEL_BRANCH_ITEM } from '../constants';

function ChannelBranch() {
  const [filter, setFilter] = useState({ page: 1, sort: 'name:asc' });
  const [isLoading, list, meta] = useChannelBranchList(filter);
  const [, deleteBranch] = useDeleteChannelBranch();

  const tableFormat = React.useMemo(() => {
    const handleEdit = (row) => {
      showDrawer({
        size: 'xs',
        title: 'Edit Branch',
        content: (onClose) => (
          <ChannelBranchModal closeModal={onClose} data={row} />
        ),
      });
    };
    const handleDelete = (row) => {
      showAlert({
        title: `Delete ${row?.name} Branch`,
        yesLabel: 'Delete',
        isLoadingKey: CHANNEL_BRANCH_ITEM,
        isLoadingMethod: 'remove',
        onYes: (closeAlert) => {
          deleteBranch(row.id, () => {
            closeAlert();
          });
        },
      });
    };
    return [
      { label: 'Name', key: 'name', id: 'name', sortKey: 'name' },
      tableEditDelete(handleEdit, handleDelete),
    ];
  }, [deleteBranch]);

  const handleAdd = () => {
    showDrawer({
      size: 'xs',
      title: 'Add Branch',
      content: (onClose) => <ChannelBranchModal closeModal={onClose} />,
    });
  };

  return (
    <div className="flex-grow flex flex-col">
      <div className="px-4">
        <SectionHeader label="Branch">
          <Button
            primary
            icon={HiDocumentAdd}
            onClick={handleAdd}
            disabled={isLoading}
          >
            Add
          </Button>
        </SectionHeader>
      </div>
      <div className="flex flex-col flex-grow bg-white">
        <Table
          data={list}
          format={tableFormat}
          isLoading={isLoading}
          onSort={setFilter}
          sort={filter.sort}
        />
      </div>
      <Pagination value={meta} onChange={setFilter} />
    </div>
  );
}

export default ChannelBranch;
